import { toast } from 'react-toastify'
import AdministratorConfigurationApi from '../../../../core/api/AdministratorConfigurationApi'
import * as styles from './_ConfigureRateLimiter.scss'
const api = new AdministratorConfigurationApi()

export const SET_EMAIL_RATE_LIMITER = 'SET_EMAIL_RATE_LIMITER'
export const FETCHING_EMAIL_RATE_LIMITER = 'FETCHING_EMAIL_RATE_LIMITER'
export const FETCHED_EMAIL_RATE_LIMITER = 'FETCHED_EMAIL_RATE_LIMITER'
export const RATE_LIMIT_SET = 'RATE_LIMIT_SET'

export const fetchingEmailRateLimiter = () => ({
  type: FETCHING_EMAIL_RATE_LIMITER
})

export const fetchedEmailRateLimiter = (emailRateLimiter) => ({
  type: FETCHED_EMAIL_RATE_LIMITER,
  payload: emailRateLimiter
})

export const setEmailRateLimiter = (emailRateLimiter) => ({
  type: SET_EMAIL_RATE_LIMITER,
  payload: emailRateLimiter
})

export function fetchEmailRateLimiter () {
  return async (dispatch) => {
    try{
      const response = await api.getEmailRateLimiter()
      dispatch({
        type: FETCHED_EMAIL_RATE_LIMITER,
        payload: response
      })
      return response
    }catch(error){
      dispatch({
        type: 'FETCH_EMAIL_RATE_LIMITER_FAILURE',
        error: error.toString()
      })
      throw error
    }
  }
}

export function updateRateLimiter (rateLimiter, administratorId) {
  return (dispatch) => {
    dispatch(fetchingEmailRateLimiter())

    const updatePayload = {
      configurationValue: rateLimiter,
      enabled: true,
      lastUpdatedBy: administratorId
    }

    api.updateEmailRateLimiter(updatePayload)
      .then(function (response) {
        toast.success('Daily email rate limit updated', {
          autoClose: 10000
        })
        dispatch(setEmailRateLimiter(updatePayload.configurationValue))
        dispatch(rateLimitSet())
      })
  }
}

export const rateLimitSet = () => ({
  type: RATE_LIMIT_SET
})

